import { OrderManagement } from '@/pages/OrderManagement'
import { DefaultView } from '@/pages/OrderManagement/All/page'
import { CarrierDispatch } from '@/pages/OrderManagement/CarrierDispatch/page'
import { OrderRequests } from '@/pages/OrderManagement/OrderRequests/page'
import {
  BookFilled,
  BookOutlined,
  CarryOutOutlined,
  ContactsOutlined,
  DiffOutlined,
  DollarCircleOutlined,
  EnvironmentOutlined,
  FileProtectOutlined,
  FileTextFilled,
  FileTextOutlined,
  FlagFilled,
  FlagOutlined,
  HistoryOutlined,
  LineChartOutlined,
  RadarChartOutlined,
  ScheduleOutlined,
  SlidersOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Admin } from '@components/Admin/Admin'
import { CounterParty } from '@components/Admin/Counterparty/CounterParty'
import { Depot } from '@components/Admin/Depot/Depot'
import { Cards } from '@components/Admin/Location/Cards/page'
import { Terminal } from '@components/Admin/Location/Terminal/Terminal'
import { Market } from '@components/Admin/Market/Market'
import { Product } from '@components/Admin/Product/Product'
import { Sites } from '@components/Admin/Site/Sites'
import { Tank } from '@components/Admin/Tank/Tank'
import { TankStrategy } from '@components/Admin/TankStrategy/TankStrategy'
import { TankTransition } from '@components/Admin/TankTransition/TankTransition'
import { Tractor } from '@components/Admin/Tractor/Tractor'
import { Trailer } from '@components/Admin/Trailer/Trailer'
import { TrailerConfig } from '@components/Admin/TrailerConfig/TrailerConfig'
import { User } from '@components/Admin/User/User'
import { AnalyticsReporting } from '@components/AnalyticsReporting'
import { Event } from '@components/AnalyticsReporting/Event/Event'
import { Forecast } from '@components/AnalyticsReporting/Forecast'
import { OrderAuditReportPage } from '@components/AnalyticsReporting/OrderAuditReport'
import { Sales } from '@components/AnalyticsReporting/Sales'
import { BulkOrderJobs } from '@components/BulkOrderJobs/BulkOrderJobs'
import { Analytics } from '@components/DriverManagement/Analytics/Analytics'
import { Carding } from '@components/DriverManagement/Carding'
import { Credentials } from '@components/DriverManagement/Credentials/page'
import { DriverFormPage } from '@components/DriverManagement/DriverForms/DriverFormPage'
import { DriverManagement } from '@components/DriverManagement/DriverManagement'
import { PayMileageBands } from '@components/DriverManagement/PayMileageBands/page'
import { PayrollReport } from '@components/DriverManagement/Payroll/PayrollReport'
import { PayrollConfig } from '@components/DriverManagement/PayrollConfig/PayrollConfig'
import { ResourcePlanner } from '@components/DriverManagement/ResourcePlanner/ResourcePlanner'
import { Schedule } from '@components/DriverManagement/Schedule/page'
import { SpecialPayConfigs } from '@components/DriverManagement/SpecialPay/SpecialPayConfigs'
import { SpecialPayOverrides } from '@components/DriverManagement/SpecialPayOverrides/SpecialPayOverrides'
import { SpecialPayRequests } from '@components/DriverManagement/SpecialPayRequests/SpecialPayRequests'
import { DwellPage } from '@components/DriverTracking/Dwell/DwellPage'
import { RoutePage } from '@components/DriverTracking/Routes/RoutePage'
import { FreightIndex } from '@components/Freight'
import { FreightLineItems } from '@components/Freight/FreightLineItems/page'
import { Launchpad } from '@components/Freight/Launchpad/page'
import { InventoryCosting } from '@components/InventoryValuation/Costing/InventoryCosting'
import { Inventory } from '@components/InventoryValuation/Inventory'
import { SwingReport } from '@components/InventoryValuation/SwingReport/SwingReport'
import { Model } from '@components/Model/Model'
import { Optimizer } from '@components/Model/Model/Optimizer'
import { SupplyLog } from '@components/Model/SupplyLog'
import { TankMonitor } from '@components/Model/System/TankMonitor/TankMonitor'
import { OperationsRequests } from '@components/OrderDispatch/OperationsRequests/OperationsRequests'
import { OrderDispatch } from '@components/OrderDispatch/OrderDispatch'
import { OrderDispatchIndex } from '@components/OrderDispatch/OrderDispatchIndex'
import { Movements } from '@components/OrderMovements/Movements'
import OrderMovements from '@components/OrderMovements/OrderMovements/OrderMovements'
import { SiteBOLs } from '@components/OrderMovements/SiteBOLs/SiteBOLs'
import { BestSupplyByTank } from '@components/Reports/BestSupplyByTank/BestSupplyByTank'
import { IntramonthPage } from '@components/Reports/DispatchDirective/Grid/Intramonth/IntramonthPage'
import { IntradayPage } from '@components/Reports/DispatchDirective/IntradayPage'
import { LoadNumberOverrides } from '@components/Reports/LoadNumberOverrides/LoadNumberOverrides'
import { LoadNumbers } from '@components/Reports/LoadNumbers/LoadNumbers'
import { SupplyDirectives } from '@components/Reports/SupplyDirectives'
import { SupplyReport } from '@components/Reports/SupplyReport/SupplyReport'
import { TankSupplyDefaults } from '@components/Reports/TankSupplyDefaults/TankSupplyDefaults'
import { OldDispatchDirective } from '@components/Reports/oldDirectives/OldDirectives'
import { ForecastManagement } from '@components/StoreMonitoring/ForecastManagement/ForecastManagement'
import { SiteMonitoringContextProvider } from '@components/StoreMonitoring/SiteMonitoringContext'
import { StoreDashboard } from '@components/StoreMonitoring/StoreDashboard/StoreDashboard'
import { MovementStoreProvider } from '@components/StoreMonitoring/StoreDetailsPage/AttendantView/EasyOrderMovements/MovementStoreProvider'
import { StoreDetail } from '@components/StoreMonitoring/StoreDetailsPage/StoreDetail'
import { SupplyManagement } from '@components/SupplyManagement/page'
import { Navigate, Outlet } from 'react-router-dom'

import { DeliveryConfig } from '@/pages/DeliveryReconciliation/DeliveryConfig/page'
import { DeliveryReconciliation } from '@/pages/DeliveryReconciliation/DeliveryReport/page'
import { InvoiceDetailPage } from '@components/Freight/Invoices/Detail/page'
import { TransactionsReportPage } from '@components/Freight/Invoices/TransactionsReport/page'
import { Invoices } from '@components/Freight/Invoices/page'
import { MaterialIcon } from '@gravitate-js/excalibrr'
import { LaunchpadWithContext } from '@components/SupplierReconciliation/Home/LaunchpadWithContext'
import { ManagementWithContext } from '@components/SupplierReconciliation/Home/ManagementWithContext'
import { SupplierReconciliation } from '@components/SupplierReconciliation/SupplierReconciliation'
import { RatebookDrillIn } from '@components/Freight/Ratebooks/Drill-in/page'
import { RatebooksPage } from '@components/Freight/Ratebooks/page'
import { SupplierConfigs } from '@components/SupplierReconciliation/SupplierConfigs/page'
import { IconMap2 } from '@tabler/icons-react'
import { InvoicesIndex } from '../Freight'
import { TaxValuations } from '../AnalyticsReporting/SupplierReconciliation/TaxValuations/page'
import { BOLTransactions } from '../AnalyticsReporting/SupplierReconciliation/BOLTransactions/page'
import { DriverTracking } from '../OrderDispatch/DriverTracking/page'

import { DriverGrid } from '../DriverManagement/Manage/DriverGrid'
import { MatchView } from '../SupplierReconciliation/MatchView'
import { MatchDetailPage } from '../SupplierReconciliation/MatchView/Detail'
import { userScopes } from '@/constants/userRoles'

type RouteConfig = {
  key?: string
  title?: string
  element?: React.ReactElement
  icon?: React.ReactElement
  hasPermission?: (scopes: Partial<Gravitate.AuthorizationResponse>) => boolean | undefined
  routes?: RouteConfig[]
  query_page?: boolean
  index?: boolean
}

type PageConfig = {
  [key: string]: RouteConfig & {
    defaultRedirect?: string
    ignoreAutoRedirect?: boolean
  }
}

export const pageConfig: PageConfig = {
  order_overview_page: {
    key: 'order_overview_page',
    icon: <FileTextOutlined />,
    title: 'Order Management',
    element: <OrderManagement />,
    defaultRedirect: 'all',
    routes: [
      {
        title: 'All',
        key: 'all',
        element: <DefaultView />,
        icon: <FileTextFilled />,
        hasPermission: (scopes) => scopes?.order_management?.all,
      },
      {
        title: 'Carrier Dispatch',
        key: 'carrier-dispatch',
        icon: <FlagFilled />,
        element: <CarrierDispatch />,
        hasPermission: (scopes) => !scopes.is_carrier && scopes?.order_management?.all,
      },
      {
        title: 'Order Requests',
        key: 'order-requests',
        icon: <EnvironmentOutlined />,
        element: <OrderRequests />,
        hasPermission: (scopes) => scopes?.delivery_requests?.view,
      },
    ],
  },
  order_dispatch: {
    key: 'order_dispatch',
    icon: <ScheduleOutlined />,
    title: 'Order Dispatch',
    element: <OrderDispatchIndex />,
    defaultRedirect: 'dispatcher',
    routes: [
      {
        title: 'Dispatch',
        key: 'dispatcher',
        element: <OrderDispatch />,
        icon: <ScheduleOutlined />,
      },
      {
        title: 'Operations Requests',
        key: 'requests',
        element: <OperationsRequests />,
        icon: <ScheduleOutlined />,
        hasPermission: (scopes) => scopes?.operations_requests?.view,
      },
      {
        title: 'Driver Tracking',
        key: 'driver_tracking',
        element: <DriverTracking />,
        icon: <IconMap2 />,
        hasPermission: (scopes) => scopes?.driver_tracking?.view,
      },
    ],
  },
  site_monitoring: {
    key: 'site_monitoring',
    icon: <EnvironmentOutlined />,
    title: 'Site Monitoring',
    defaultRedirect: 'dashboard',
    ignoreAutoRedirect: true,
    element: (
      <SiteMonitoringContextProvider>
        <Outlet />
      </SiteMonitoringContextProvider>
    ),
    routes: [
      {
        hasPermission: (scopes) => scopes?.store_ids?.length !== 1,
        key: 'dashboard',
        element: <StoreDashboard />,
        icon: <EnvironmentOutlined />,
        title: 'Dashboard',
      },
      {
        title: 'Store Details',
        query_page: true,
        key: ':storeId',
        element: (
          <MovementStoreProvider>
            <StoreDetail />
          </MovementStoreProvider>
        ),
        icon: <EnvironmentOutlined />,
      },
      {
        title: 'Forecast Management',
        key: 'forecast_management',
        element: <ForecastManagement />,
        hasPermission: (scopes) => scopes.forecast_management_page,
      },
    ],
  },
  order_movements_page: {
    key: 'order_movements_page',
    icon: <BookOutlined />,
    title: 'Movements',
    element: <Movements />,
    defaultRedirect: 'report',
    routes: [
      {
        title: 'Order Movements',
        key: 'report',
        element: <OrderMovements />,
        icon: <BookOutlined />,
      },
      {
        title: 'Site BOLs',
        key: 'site_bols',
        element: <SiteBOLs />,
        icon: <RadarChartOutlined />,
      },
    ],
  },
  supply_directive: {
    key: 'supply_directive',
    icon: <DollarCircleOutlined />,
    title: 'Supply / Directives',
    element: <SupplyDirectives />,
    defaultRedirect: 'price_management',
    routes: [
      {
        title: 'Supply',
        key: 'supply_report',
        hasPermission: (scopes) =>
          !!scopes.supply_directive.price_management?.view || !!scopes.supply_directive.reports,
        routes: [
          {
            title: 'Supply Management',
            key: 'price_management',
            element: <SupplyManagement />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => Boolean(scopes.supply_directive.price_management),
          },
          {
            title: 'Supply Report',
            key: 'supply_report',
            element: <SupplyReport />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.supply_directive.reports?.daily_supply && !scopes.is_carrier,
          },
          {
            title: 'Best Supply By Tank',
            key: 'best_supply_by_tank',
            element: <BestSupplyByTank />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.supply_directive.best_supply_by_tank,
          },
          {
            title: 'Tank Supply Defaults',
            key: 'tank_supply_defaults',
            element: <TankSupplyDefaults />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => scopes.supply_directive.reports && !scopes.is_carrier,
          },
          {
            title: 'Load Numbers',
            key: 'load_numbers',
            element: <LoadNumbers />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.supply_directive.reports && !scopes.is_carrier,
          },
          {
            title: 'Load Number Overrides',
            key: 'load_number_overrides',
            element: <LoadNumberOverrides />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.supply_directive.load_number_override && !scopes.is_carrier,
          },
        ],
      },

      {
        title: 'Directives',
        key: 'directive_reports',
        hasPermission: (scopes) =>
          (scopes.supply_directive.intraday || scopes.supply_directive.supply_view?.view) && !scopes.is_carrier,
        routes: [
          {
            title: 'Intraday View',
            key: 'intraday_view',
            icon: <FlagFilled />,
            element: <IntradayPage />,
            hasPermission: (scopes) => scopes.supply_directive.intraday,
          },
          {
            title: 'Supply View',
            key: 'supply_view',
            icon: <FlagFilled />,
            element: <IntramonthPage />,
            hasPermission: (scopes) => scopes.supply_directive.supply_view?.view,
          },
          {
            title: 'Legacy View',
            key: 'legacy_view',
            element: <OldDispatchDirective />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.supply_directive?.intraday,
          },
        ],
      },
    ],
  },
  model: {
    key: 'model',
    icon: <SlidersOutlined />,
    title: 'Model Management',
    element: <Model />,
    defaultRedirect: 'model-optimizer',
    routes: [
      {
        title: 'Model Optimizer',
        key: 'model-optimizer',
        element: <Optimizer />,
        icon: <FileTextFilled />,
      },
      {
        title: 'Supply Log',
        key: 'supply-log',
        element: <SupplyLog />,
        icon: <FileTextFilled />,
      },
      {
        title: 'Bulk Order Jobs',
        key: 'bulk-order-jobs',
        icon: <CarryOutOutlined />,
        element: <BulkOrderJobs />,
        hasPermission: (scopes) => scopes?.smart_supply,
      },
      {
        title: 'Tank Monitor',
        key: 'tank-monitor',
        icon: <FlagFilled />,
        element: <TankMonitor />,
      },
    ],
  },
  driver: {
    key: 'driver',
    icon: <ContactsOutlined />,
    title: 'Driver Management',
    element: <DriverManagement />,
    defaultRedirect: 'schedule',
    routes: [
      {
        title: 'Manage',
        key: 'manage',
        hasPermission: (scopes) => Boolean(scopes.driver.info || scopes.driver.manage),
        routes: [
          {
            title: 'Schedule',
            key: 'schedule',
            element: <Schedule />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => scopes.driver.schedules?.view,
          },
          {
            title: 'Resource Planner',
            key: 'resource_planner',
            icon: <FlagFilled />,
            element: <ResourcePlanner />,
            hasPermission: (scopes) => scopes?.driver.schedules?.view,
          },
          {
            title: 'Driver Info',
            key: 'driver_info',
            icon: <FlagFilled />,
            element: <DriverGrid />,
            hasPermission: (scopes) => scopes.driver.info?.view,
          },
          {
            title: 'Carding',
            key: 'carding',
            element: <Carding />,
          },
          {
            title: 'Credentials',
            key: 'credentials',
            element: <Credentials />,
          },
          {
            title: 'Analytics',
            key: 'driver_analytics',
            icon: <FlagFilled />,
            element: <Analytics />,
            hasPermission: (scopes) => scopes?.driver.driver_analytics,
          },
          {
            title: 'Forms',
            key: 'driver_forms',
            icon: <FlagFilled />,
            element: <DriverFormPage />,
          },
        ],
      },
      {
        title: 'Payroll',
        key: 'payroll',
        hasPermission: (scopes) => scopes.driver.payroll_report?.view || scopes.driver.special_pay_request?.view,
        routes: [
          {
            title: 'Payroll Report',
            key: 'payroll_overview',
            element: <PayrollReport />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => scopes.driver.payroll_report?.view,
          },

          {
            title: 'Special Pay Requests',
            key: 'special_requests',
            element: <SpecialPayRequests />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.driver.special_pay_request?.view,
          },
        ],
      },
      {
        title: 'Payroll Config',
        key: 'pay-config',
        hasPermission: (scopes) => scopes.driver.special_pay || scopes.driver.automatic_pay,
        routes: [
          {
            title: 'Automatic Pay Config',
            key: 'automatic_pay',
            element: <PayrollConfig />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.driver.automatic_pay,
          },
          {
            title: 'Pay Mileage Bands',
            key: 'pay_mileage_bands',
            element: <PayMileageBands />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.driver.automatic_pay,
          },
          {
            title: 'Special Pay Config',
            key: 'special_pay',
            element: <SpecialPayConfigs />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.driver.special_pay,
          },
          {
            title: 'Special Pay Overrides',
            key: 'specialpay_overrides',
            element: <SpecialPayOverrides />,
            icon: <FlagFilled />,
          },
        ],
      },
    ],
  },
  valuation: {
    title: 'Inventory',
    key: 'valuation',
    icon: <RadarChartOutlined />,
    element: <Inventory />,
    defaultRedirect: 'costing',
    routes: [
      {
        title: 'History',
        key: 'history',
        element: <SwingReport />,
        routes: [
          {
            title: 'Costing',
            key: 'costing',
            element: <InventoryCosting />,
          },
          {
            title: 'Swing Report',
            key: 'swing_report',
            element: <SwingReport />,
          },
        ],
      },
      {
        title: 'Delivery Reconciliation',
        key: 'delivery_reconciliation',
        element: <DeliveryReconciliation />,
        hasPermission: (scopes) => scopes?.delivery_reconciliation?.read,
        routes: [
          {
            title: 'Delivery Report',
            key: 'delivery_report',
            element: <DeliveryReconciliation />,
          },
          {
            title: 'Delivery Config',
            key: 'delivery_config',
            element: <DeliveryConfig />,
          },
        ],
      },
    ],
  },
  freight: {
    key: 'freight',
    icon: <CarryOutOutlined />,
    title: 'Freight',
    element: <FreightIndex />,
    routes: [
      {
        title: 'Launchpad',
        key: 'launchpad',
        element: <Launchpad />,
        hasPermission: (scopes) => !scopes?.is_carrier,
      },
      {
        title: 'Freight Line Items',
        key: 'freight_line_items',
        element: <FreightLineItems />,
        hasPermission: (scopes) => !scopes?.is_carrier,
      },
      {
        title: 'Ratebooks',
        key: 'ratebooks',
        defaultRedirect: 'ratebooks',
        icon: <MaterialIcon icon='rate_review' />,
        element: <Outlet />,
        hasPermission: (scopes) => !scopes?.is_carrier,
        routes: [
          {
            title: 'Customer Ratebooks',
            key: 'ratebooks',
            element: <RatebooksPage type='customer' />,
            icon: <UserOutlined />,
            hasPermission: (scopes) => !scopes?.is_carrier && scopes.freight?.customer_ratebook,
          },
          {
            title: 'Carrier Ratebooks',
            key: 'carrier_books',
            element: <RatebooksPage type='carrier' />,
            icon: <FlagOutlined />,
            hasPermission: (scopes) => !scopes?.is_carrier && scopes.freight?.carrier_ratebook,
          },
        ],
      },
      {
        title: 'Ratebook Details',
        key: 'ratebooks/:id',
        query_page: true,
        element: <RatebookDrillIn />,
        hasPermission: (scopes) => !scopes?.is_carrier,
      },
      {
        title: 'Ratebook Details',
        key: 'carrier_books/:id',
        query_page: true,
        element: <RatebookDrillIn />,
        hasPermission: (scopes) => !scopes?.is_carrier,
      },
      {
        title: 'Invoices',
        key: 'invoices',
        element: <Invoices />,
        hasPermission: (scopes) => scopes?.is_carrier,
      },
      {
        title: 'Invoices',
        key: 'invoices',
        element: <InvoicesIndex />,
        defaultRedirect: 'invoices',
        hasPermission: (scopes) => !scopes?.is_carrier,
        routes: [
          {
            title: 'Invoices',
            key: 'invoices',
            element: <Invoices />,
          },
          {
            title: 'Transactions Report',
            key: 'transactions-report',
            element: <TransactionsReportPage />,
            hasPermission: (scopes) => !scopes?.is_carrier,
          },
        ],
      },
      {
        title: 'Invoice Details',
        key: 'invoices/:id',
        query_page: true,
        element: <InvoiceDetailPage />,
      },
    ],
  },
  reporting: {
    key: 'reporting',
    icon: <LineChartOutlined />,
    title: 'Analytics / Reporting',
    element: <AnalyticsReporting />,
    defaultRedirect: 'order_audit',
    routes: [
      {
        title: 'Forecast',
        key: 'forecast',
        element: <Forecast />,
        hasPermission: (scopes) => scopes?.reporting?.forecast_report,
      },
      {
        title: 'Sales',
        key: 'sales',
        element: <Sales />,
        hasPermission: (scopes) => scopes?.reporting?.sales_report,
      },
      {
        title: 'Order Audit Report',
        key: 'order_audit',
        element: <OrderAuditReportPage />,
        hasPermission: (scopes) => scopes?.reporting?.order_audit,
      },
      {
        title: 'Events',
        key: 'event',
        element: <Event />,
        icon: <FlagFilled />,
      },
      {
        title: 'Supplier Reconciliation',
        key: 'supplier_reconciliation',
        hasPermission: (scopes) => scopes?.scopes?.find((s) => s === 'sr'),
        routes: [
          {
            title: 'Tax Valuations',
            key: 'taxes',
            element: <TaxValuations />,
            icon: <FlagFilled />,
          },
          {
            title: 'BOL Transactions',
            key: 'bol_transactions',
            element: <BOLTransactions />,
            icon: <FlagFilled />,
          },
        ],
      },
    ],
  },
  // logistics: {
  //   key: 'admin',
  //   icon: <CarOutlined />,
  //   title: 'Logistics',
  //   defaultRedirect: 'dwell',
  //   routes: [
  //     {
  //       title: 'Dwell Management',
  //       key: 'dwell',
  //       element: <DwellPage />,
  //     },
  //   ],
  // },
  admin: {
    key: 'admin',
    icon: <DiffOutlined />,
    title: 'Admin',
    element: <Admin />,
    defaultRedirect: 'sites',
    routes: [
      {
        title: 'Site',
        key: 'site_config',
        hasPermission: (scopes) => scopes.admin?.site_read || scopes.admin?.tank_transition_read,
        routes: [
          {
            index: true,
            element: <Navigate to={'sites'} />,
            hasPermission: (scopes) => scopes.admin?.site_read,
          },
          {
            index: true,
            element: <Navigate to={'transition'} />,
            hasPermission: (scopes) => !scopes.admin?.site_read && scopes.admin?.tank_transition_read,
          },
          {
            title: 'Sites',
            key: 'sites',
            element: <Sites />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => scopes.admin?.site_read,
          },
          {
            title: 'Tank',
            key: 'tank',
            element: <Tank />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => scopes.admin?.site_read,
          },
          {
            title: 'Product',
            key: 'product',
            element: <Product />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => scopes.admin?.site_read,
          },
          {
            title: 'Tank Transition',
            key: 'transition',
            element: <TankTransition />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.admin?.tank_transition_read || scopes.admin?.site_read,
          },
          {
            title: 'Tank Strategy',
            key: 'strategy',
            element: <TankStrategy />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.admin?.site_read,
          },
        ],
      },
      {
        title: 'Location',
        key: 'location_config',
        hasPermission: (scopes) => scopes.admin?.location_read,
        routes: [
          {
            title: 'Market',
            key: 'market',
            element: <Market />,
            icon: <FlagFilled />,
          },
          {
            title: 'Terminal',
            key: 'terminal',
            element: <Terminal />,
            icon: <FileTextFilled />,
          },
          {
            title: 'Cards',
            key: 'cards',
            element: <Cards />,
          },
          {
            title: 'Depot',
            key: 'depot',
            element: <Depot />,
            icon: <FileTextFilled />,
          },
        ],
      },
      {
        title: 'Vehicle',
        key: 'vehicle_config',
        hasPermission: (scopes) => scopes.admin?.vehicle_read,
        routes: [
          {
            title: 'Trailer',
            key: 'trailer',
            element: <Trailer />,
            icon: <FlagFilled />,
          },
          {
            title: 'Trailer Config',
            key: 'config',
            element: <TrailerConfig />,
            icon: <FlagFilled />,
          },
          {
            title: 'Tractor',
            key: 'tractor',
            element: <Tractor />,
            icon: <FlagFilled />,
          },
        ],
      },

      {
        title: 'User Groups',
        key: 'user_group_config',
        hasPermission: (scopes) => scopes.admin?.user,
        routes: [
          {
            title: 'Counterparty',
            key: 'counterparty',
            element: <CounterParty />,
            icon: <FileTextFilled />,
            hasPermission: (scopes) => !scopes.is_carrier,
          },
          {
            title: 'User',
            key: 'user',
            element: <User />,
            icon: <FlagFilled />,
            hasPermission: (scopes) => scopes.admin?.user,
          },
        ],
      },
      {
        title: 'Configurations',
        key: 'configurations',
        hasPermission: (scopes) => scopes.admin?.location_write,
        routes: [
          {
            title: 'Dwell Management',
            key: 'dwell',
            element: <DwellPage />,
            icon: <HistoryOutlined />,
            hasPermission: (scopes) => scopes.admin?.location_write,
          },
          {
            title: 'Route Management',
            key: 'route',
            element: <RoutePage />,
            hasPermission: (scopes) => scopes.admin?.location_write,
          },
        ],
      },
    ],
  },
  supplier_rec: {
    key: 'supplier_rec',
    icon: <FileProtectOutlined />,
    title: 'Supplier Reconciliation',
    element: <SupplierReconciliation />,
    defaultRedirect: 'launchpad',
    hasPermission: (scopes) => true,

    routes: [
      {
        title: 'Launchpad',
        key: 'launchpad',
        element: <LaunchpadWithContext />,
        icon: <FlagFilled />,
        hasPermission: (scopes) => true,
      },
      {
        title: 'Management',
        key: 'management',
        element: <ManagementWithContext />,
        icon: <FileTextFilled />,
        hasPermission: (scopes) => true,
      },
      {
        title: 'Invoices',
        key: 'invoices',
        routes: [
          {
            title: 'Match View',
            key: 'match_view',
            element: <MatchView />,
            icon: <FileTextOutlined />,
            hasPermission: () => true,
          },
        ],
      },
      {
        title: 'Match Details',
        key: 'match_view/:id',
        query_page: true,
        element: <MatchDetailPage />,
        hasPermission: () => true,
      },
      {
        title: 'Configuration',
        key: 'configuration',

        routes: [
          {
            title: 'Supplier Configurations',
            key: 'supplier_configs',
            element: <SupplierConfigs />,
            icon: <FileTextFilled />,
            hasPermission: () => true,
          },
        ],
      },
    ],
  },
}

function findChildRouteTitle(childRouteKey: string, routes?: RouteConfig[]): string {
  let childRouteTitle = ''
  if (!routes) return childRouteTitle

  for (const route of routes) {
    if (route.key === childRouteKey) {
      return route.title
    }
    childRouteTitle = findChildRouteTitle(childRouteKey, route.routes)
    if (childRouteTitle) return childRouteTitle
  }
  return childRouteTitle
}

export function findPageTitle(url: string, pageConfig: PageConfig): string {
  const [, parentRouteKey, childRouteKey] = url.split('/')
  const parentRouteConfig = pageConfig[parentRouteKey]
  if (!parentRouteConfig) return 'Supply & Dispatch'

  const childRouteTitle = findChildRouteTitle(childRouteKey, parentRouteConfig.routes)
  return childRouteTitle ? `${parentRouteConfig.title} | ${childRouteTitle}` : parentRouteConfig.title
}
